import React from 'react';
import Label from 'components/form/Label/Label';
import './SomethingWrong.scss';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

export const SomethingWrong = props => {
  const datatestid = props.datatestid ? props.datatestid : null;

  return (
    <div
      className="SomethingWrong system_ltblue_lb025 padT24 padB24"
      data-testid={datatestid}
    >
      <Label type="H4" typeHeader={'h4'} className="text-20">
        Something wrong or it was not you?
      </Label>
      <div className="desktopHide pad4"></div>
      <div className="mobileHide pad8"></div>
      <Label type="Body-2" className="padB24">
        Our specialists are available Monday-Friday, 7am-5pm PT to help with
        issues like credit report errors, ID theft, and more.
      </Label>
      <FlexContainer
        alignItemsCenter
        className="justify-center callNow padTB10 m-padTB16 text-16 bold format40 m-format100"
      >
        <a href="tel:18557999111">Call 1-855-799-9111</a>
      </FlexContainer>
    </div>
  );
};
